import React from 'react';
import {connect} from "react-redux";
import PropTypes from 'prop-types';

import UserFieldElement from '../../../reusable/UserFieldElement';
import UserFieldDataType from "../../../../utils/enums/UserFieldDataTypeEnum";

import {NotificationManager} from "react-notifications";
import {confirm} from "../../../../utils/confirmDialog";
import * as AdminActions from "../../../../actions/admin";

//import PriceAdditionsDialog from '../dialogs/PriceAdditionsDialog';

export const defaultState = {
    MinPuljeTilFord: '0',
    Praemiefaktor_A: '5',
    Praemiefaktor_B: '10',
    PuljePuljepraemier: false,
    ElitePuljepraemier: false,
    Z_Puljepraemier: false,
    R_Puljepraemier: false,
    KunEnKontantpraemiePrSlag: false,
};
class SettingsPrizes extends React.Component {

    static propTypes = {
        section: PropTypes.object.isRequired,
        sectionNo: PropTypes.string.isRequired,
        editMode: PropTypes.bool.isRequired,
        isDDB: PropTypes.bool.isRequired,
        isSection: PropTypes.bool.isRequired,
        isClub: PropTypes.bool.isRequired,
        setAllowNew: PropTypes.func.isRequired,
    };

    static defaultProps = {
        editMode: false,
    };
    constructor(props) {
        super(props);
        const additionalStates = {
            priceType: null,
            editIx: null,
        };
        this.state = Object.assign(additionalStates, this.getStateFromStore(props));
    }

    componentDidMount(props) {
        this.props.dispatch(AdminActions.getSectionPrizes(this.props.sectionNo));
    }

    componentWillReceiveProps(nextProps) {
        if(!nextProps.editMode || ((nextProps.section === null && this.props.section !== null) || (nextProps.section !== null && (this.props.section === null || this.props.sectionNo !== nextProps.sectionNo)))) this.setState(this.getStateFromStore(nextProps));
        if(!nextProps.section.hasOwnProperty('sectionPrizesRead')) this.props.dispatch(AdminActions.getSectionPrizes(nextProps.sectionNo));
        if(this.state.priceType !== null) this.props.setAllowNew(true)
    }

    fields = [];

    getStateFromStore(props) {
        if (props.section.Markering === null)
            return defaultState;
        else {
            const section = props.section;
            const marker = section.Markering;

            return {
                MinPuljeTilFord:           marker.MinPuljeTilFord === null ? '0': marker.MinPuljeTilFord.toString(),
                Praemiefaktor_A:           marker.Praemiefaktor_A === null ? '5': marker.Praemiefaktor_A.toString(),
                Praemiefaktor_B:           marker.Praemiefaktor_B === null ? '10': marker.Praemiefaktor_B.toString(),
                PuljePuljepraemier:        marker.PuljePuljepraemier === null ? false: Boolean(marker.PuljePuljepraemier),
                ElitePuljepraemier:        marker.ElitePuljepraemier === null ? false: Boolean(marker.ElitePuljepraemier),
                Z_Puljepraemier:           marker.Z_Puljepraemier === null ? false: Boolean(marker.Z_Puljepraemier),
                R_Puljepraemier:           marker.R_Puljepraemier === null ? false: Boolean(marker.R_Puljepraemier),
                KunEnKontantpraemiePrSlag: marker.KunEnKontantpraemiePrSlag === null ? false: Boolean(marker.KunEnKontantpraemiePrSlag),
                sectionPrizesRead:         section.hasOwnProperty('sectionPrizesRead') ? section.sectionPrizesRead : false
            }
        }
    }

    render() {
        return <div className={"form-page race-prices settings " + (this.state.editIx !== null ? "editable" : "read-only")}>
            <div className="top-left-panel">
                <div className="outer-content">
                    <div className="inner-content">
                        <UserFieldElement
                            dataType={UserFieldDataType.options}
                            className=""
                            containerClassName="display-inline-block"
                            disabled={this.state.editIx !== null}
                            name="priceType"
                            id="priceType"
                            value={this.state.priceType}
                            options={this.props.isClub ? [
                                {key: 'kontant', value: 'Kontantpræmier', disabled: this.state.editIx !== null},
                                {key: 'slag', value: 'Slagpræmier', disabled: this.state.editIx !== null},
                            ] : [
                                {key: 'kontant', value: 'Kontantpræmier', disabled: this.state.editIx !== null},
                                {key: 'slagspil', value: 'Slagspilspræmier', disabled: this.state.editIx !== null},
                                {key: 'espil', value: 'E-spilspræmier', disabled: this.state.editIx !== null},
                                {key: 'pspil', value: 'P-spilspræmier', disabled: this.state.editIx !== null},
                                {key: 'zspil', value: 'Z-spilspræmier', disabled: this.state.editIx !== null},
                                {key: 'dm', value: 'DM-præmier', disabled: this.state.editIx !== null},
                                {key: 'slag', value: 'Slagpræmier', disabled: this.state.editIx !== null},
                                //{key: 'serie', value: 'Seriepræmier', disabled: this.state.editIx !== null},
                                //{key: 'derby', value: 'Derbypræmier', disabled: this.state.editIx !== null || this.props.isDDB === false},
                            ]}
                            autoCheckErrors={true}
                            required={false}
                            hideErrWhenFocused={true}
                            hideErrUntilFocused={true}
                            onChange={e => {
                                this.setState({priceType: e.target.value});
                                this.props.setAllowNew(true);
                            }}
                            ref={instance => { this.fields[0] = instance; }}
                        />
                    </div>
                </div>
            </div>
            <div className="top-right-panel">
                <div id="data-table" className="outer-content">
                    <div className="inner-content">
                        <table className="data-table">
                            <thead>
                            <tr>
                                <th>Antal</th>
                                <th>Værdi</th>
                                {this.props.isDDB ? <th>Sektion</th> : null}
                                <th></th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.priceType !== null && this.props.section[this.state.priceType] ? this.props.section[this.state.priceType].sort((p1, p2) => {
                                if (p1.Sektionsnr < p2.Sektionsnr) return -1;
                                if (p1.Sektionsnr > p2.Sektionsnr) return 1;
                                if (p1.Vaerdi > p2.Vaerdi) return -1;
                                if (p1.Vaerdi < p2.Vaerdi) return 1;
                                return 0;
                            }).concat(this.state.editIx === 'new/new' ? [{Sektionsnr: 'new', Vaerdi: 'new'}] : []).map(prize => <tr key={prize.Sektionsnr + '/' + prize.Vaerdi} id={'row-' + prize.Sektionsnr + '-' + prize.Vaerdi}>
                                <td>{
                                    this.state.editIx === prize.Sektionsnr + '/' + prize.Vaerdi ? <UserFieldElement dataType={UserFieldDataType.int} placeholder="" className="field75" containerClassName="display-inline-block"
                                                                                                                 name="Antal" id="Antal" value={this.state.Antal}
                                                                                                                 autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                                                                                 onChange={this.onStandardFieldChange}
                                                                                                                 ref={instance => { this.fields[1] = instance; }}
                                    /> : prize.Antal
                                }</td>
                                <td>{
                                    this.state.editIx === prize.Sektionsnr + '/' + prize.Vaerdi ? <UserFieldElement dataType={UserFieldDataType.float} placeholder="" className="field100" containerClassName="display-inline-block"
                                                                                                                 name="Vaerdi" id="Vaerdi" value={this.state.Vaerdi}
                                                                                                                 autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                                                                                 onChange={this.onStandardFieldChange}
                                                                                                                 ref={instance => { this.fields[2] = instance; }}
                                    /> : String(prize.Vaerdi).replace('.', ',')
                                }</td>
                                {this.props.isDDB ? <td>{
                                    this.state.editIx === prize.Sektionsnr + '/' + prize.Vaerdi ? <UserFieldElement dataType={UserFieldDataType.string} placeholder="" className="field100" containerClassName="display-inline-block"
                                                                                                                 name="Sektionsnr" id="Sektionsnr" maxLength="6" value={this.state.Sektionsnr}
                                                                                                                 autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                                                                                 onChange={this.onStandardFieldChange}
                                                                                                                 ref={instance => { this.fields[3] = instance; }}
                                    /> : prize.Sektionsnr
                                }</td> : null}
                                <td>{
                                    this.state.editIx === prize.Sektionsnr + '/' + prize.Vaerdi ? [
                                        <i key={0} className="fa fa-save clickable" title="Gem præmie" onClick={this.saveRow}/>,
                                        <i key={1} className="fa fa-undo clickable" title="Annuller" onClick={this.cancelEdit}/>
                                    ] : [
                                        <i key={0} className={"fa fa-pencil " + (this.state.editIx === null ? 'clickable' : 'disabled')} title="Rediger række" onClick={() => {
                                            if (this.state.editIx === null){
                                                this.setState({
                                                    Sektionsnr: prize.Sektionsnr,
                                                    Vaerdi: String(prize.Vaerdi).replace('.', ','),
                                                    Antal: prize.Antal === null ? '' : String(prize.Antal),
                                                    oldSektion: String(prize.Sektionsnr),
                                                    oldVaerdi: String(prize.Vaerdi),
                                                    editIx: prize.Sektionsnr + '/' + prize.Vaerdi,
                                                });
                                            }
                                        }}/>,
                                        <i key={1}
                                           className={"fa fa-trash " + (this.state.editIx === null ? 'clickable' : 'disabled')} title="Slet præmie" onClick={() => {
                                            if (this.state.editIx === null) confirm("Slet", <span>Ønsker du at slette præmien på <b>{prize.Vaerdi} DKK</b>{prize.Sektionsnr === '' ? '' : <span> for sektion <b>{prize.Sektionsnr}</b></span>}?</span>, () => {
                                                this.props.dispatch(AdminActions.deleteSectionPrize(this.props.sectionNo, this.state.priceType, prize.Sektionsnr, prize.Vaerdi,   () => {
                                                    NotificationManager.success("Præmien på " + prize.Vaerdi + ' DKK' + (prize.Sektionsnr === '' ? '' : ' for sektion ' + prize.Sektionsnr) + " er slettet.", "Sletning", 4000);
                                                }));
                                            });
                                        }}/>
                                    ]
                                }</td>
                            </tr>) : null}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div className={'bottom-left-settings-panel'}>
                <div className="outer-content">
                    {this.props.isClub ?
                        <div className="inner-content-lower flex">
                            <div className={"normal-width"}>
                                <label htmlFor="KunEnKontantpraemiePrSlag">Uddel kun én kontantpræmie pr. slag</label>
                            </div>
                            <div>
                                <span>
                                    <input id="KunEnKontantpraemiePrSlag" name="KunEnKontantpraemiePrSlag" type="checkbox" checked={this.state.KunEnKontantpraemiePrSlag}
                                           disabled={!this.props.editMode} onChange = {this.onPoolPriceClick}/>
                                </span>
                            </div>
                        </div>
                    : [
                        <div className="inner-content-upper flex" style={{paddingBottom:"30px"}}>
                            <div className={"normal-width"}>
                                <label style={{paddingRight:"70px"}}>Minimum P-spil til fordeling:</label>
                                {this.props.editMode ?
                                    <UserFieldElement
                                        dataType={UserFieldDataType.int}
                                        placeholder=""
                                        className="field-1 very-small-field"
                                        containerClassName="display-inline-block"
                                        name="MinPuljeTilFord"
                                        id="MinPuljeTilFord"
                                        value={this.state.MinPuljeTilFord}
                                        autoCheckErrors={true}
                                        required={false}
                                        hideErrWhenFocused={true}
                                        hideErrUntilFocused={true}
                                        onChange={this.onStandardFieldChange}
                                        ref={instance => { this.fields[1] = instance; }}
                                    />
                                    : <span className="value-text">{this.state.MinPuljeTilFord}</span>}
                            </div>
                            <div>
                                <div>
                                    <label>Præmier i A-spil =</label>
                                    {this.props.editMode ?
                                        <UserFieldElement
                                            dataType={UserFieldDataType.int}
                                            placeholder=""
                                            className="field-1 very-small-field"
                                            containerClassName="display-inline-block"
                                            name="Praemiefaktor_A"
                                            id="Praemiefaktor_A"
                                            value={this.state.Praemiefaktor_A}
                                            autoCheckErrors={true}
                                            required={false}
                                            hideErrWhenFocused={true}
                                            hideErrUntilFocused={true}
                                            onChange={this.onStandardFieldChange}
                                            ref={instance => { this.fields[1] = instance; }}
                                        />
                                        : <span className="value-text">{this.state.Praemiefaktor_A}</span>}
                                    <label>gange indsats</label>
                                </div>
                                <div>
                                    <label>Præmier i B-spil =</label>
                                    {this.props.editMode ?
                                        <UserFieldElement
                                            dataType={UserFieldDataType.int}
                                            placeholder=""
                                            className="field-1 very-small-field"
                                            containerClassName="display-inline-block"
                                            name="Praemiefaktor_B"
                                            id="Praemiefaktor_B"
                                            value={this.state.Praemiefaktor_B}
                                            autoCheckErrors={true}
                                            required={false}
                                            hideErrWhenFocused={true}
                                            hideErrUntilFocused={true}
                                            onChange={this.onStandardFieldChange}
                                            ref={instance => { this.fields[1] = instance; }}
                                        />
                                        : <span className="value-text">{this.state.Praemiefaktor_B}</span>}
                                    <label>gange indsats</label>
                                </div>
                            </div>
                        </div>,

                        <div className="inner-content-lower ">
                            <div className="flex">
                                <div className={"normal-width"}>
                                    <label>Præmiepulje kan ikke overstige samlede indskud</label>
                                </div>
                                <div>
                                    <span className="pool-prices">
                                        <span className="pool-prices-option">
                                            <label htmlFor="PuljePuljepraemier" className={!this.props.editMode ? 'disabled' : ''}>Pulje</label>
                                            <input id="PuljePuljepraemier" name="PuljePuljepraemier" type="checkbox" checked={this.state.PuljePuljepraemier}
                                                   disabled={!this.props.editMode} onChange = {this.onPoolPriceClick}/>
                                        </span>
                                        <span className="pool-prices-option">
                                            <label htmlFor="ElitePuljepraemier" className={!this.props.editMode ? 'disabled' : ''}>Elite</label>
                                            <input id="ElitePuljepraemier" name="ElitePuljepraemier" type="checkbox" checked={this.state.ElitePuljepraemier}
                                                   disabled={!this.props.editMode} onChange = {this.onPoolPriceClick}/>
                                        </span>
                                        <span className="pool-prices-option">
                                            <label htmlFor="Z_Puljepraemier" className={!this.props.editMode ? 'disabled' : ''}>Z-spil</label>
                                            <input id="Z_Puljepraemier" name="Z_Puljepraemier" type="checkbox" checked={this.state.Z_Puljepraemier}
                                                   disabled={!this.props.editMode} onChange = {this.onPoolPriceClick}/>
                                        </span>
                                        <span className="pool-prices-option">
                                            <label htmlFor="R_Puljepraemier" className={!this.props.editMode ? 'disabled' : ''}>DM</label>
                                            <input id="R_Puljepraemier" name="R_Puljepraemier" type="checkbox" checked={this.state.R_Puljepraemier}
                                                   disabled={!this.props.editMode} onChange = {this.onPoolPriceClick}/>
                                        </span>
                                    </span>
                                </div>
                            </div>
                            <div className="flex">
                                <div className={"normal-width"}>
                                    <span className="pool-prices">
                                        <span className="pool-prices-option">
                                            <label htmlFor="KunEnKontantpraemiePrSlag">Uddel kun én kontantpræmie pr. slag</label>
                                            <span>
                                                <input id="KunEnKontantpraemiePrSlag" name="KunEnKontantpraemiePrSlag" type="checkbox" checked={this.state.KunEnKontantpraemiePrSlag}
                                                       disabled={!this.props.editMode} onChange = {this.onPoolPriceClick}/>
                                            </span>
                                        </span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    ]}
                </div>
            </div>
        </div>
    }

    onStandardFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.value});
    };

    onPoolPriceClick = (e) => {
        this.setState({[e.target.name]: e.target.checked})
    };

    allInputValid = () => {
        let result = true;
        this.fields.forEach((field, ix) => {
            if (field && !field.isValid()) result = false;
        });
        return result;
    };

    saveRow = () => {
        if (this.allInputValid()) {
            const entity = {
                Antal: this.state.Antal === '' ? null : Number(this.state.Antal),
                Vaerdi: this.state.Vaerdi === '' ? null : Number(this.state.Vaerdi.replace(',', '.')),
            };

            if(this.props.isDDB){
                entity.Sektionsnr = this.state.Sektionsnr === '' ? null : this.state.Sektionsnr
            }

            if (this.state.editIx === 'new/new') {
                this.props.dispatch(AdminActions.createSectionPrize(this.props.sectionNo, this.state.priceType, entity, () => {
                    NotificationManager.success("Præmien på " + this.state.Vaerdi + " DKK" + (this.state.Sektionsnr === '' ? '' : ' for sektion ' + this.state.Sektionsnr) + " er oprettet.", "Oprettelse", 4000);
                    this.setState({editIx: null});
                    /*setTimeout(function () {
                        const currentRow = document.getElementById("row-" + this.state.Sektionsnr + "-" + this.state.Vaerdi);
                        currentRow.scrollIntoView(false);
                    }.bind(this));*/
                }));
            } else this.props.dispatch(AdminActions.updateSectionPrize(this.props.sectionNo, this.state.priceType, this.props.isDDB ? this.state.oldSektion : 'null', this.state.oldVaerdi,  entity, () => {
                NotificationManager.success("Præmien på " + this.state.Vaerdi + " DKK" + (this.state.Sektionsnr === '' ? '' : ' for sektion ' + this.state.Sektionsnr) + " er opdateret.", "Opdatering", 4000);
                this.setState({editIx: null});
                /*setTimeout(function () {
                    const currentRow = document.getElementById("row-" + this.state.Sektionsnr + "-" + this.state.Vaerdi);
                    currentRow.scrollIntoView(false);
                }.bind(this));*/
            }));
        } else {
            this.fields.forEach((field) => {
                field.setState({visited: true});
            });
        }
    }

    createNew = () => {
        this.setState({
            Antal: '1',
            Vaerdi: '',
            Sektionsnr: '',
            editIx: 'new/new'
        });
        setTimeout(function () {
            const content = document.getElementById("data-table");
            content.scrollTop = content.scrollHeight;
        });
    };

    cancelEdit = () => {
        this.setState({editIx: null});
    };

    save = (onSuccess = null) => {
        if (this.allInputValid()) {
            const entity = {
                MinPuljeTilFord:           this.state.MinPuljeTilFord === null               ? 0:    Number(this.state.MinPuljeTilFord),
                Praemiefaktor_A:           this.state.Praemiefaktor_A === null               ? 5:    Number(this.state.Praemiefaktor_A),
                Praemiefaktor_B:           this.state.Praemiefaktor_B === null               ? 10:   Number(this.state.Praemiefaktor_B),
                PuljePuljepraemier:        this.state.PuljePuljepraemier === null            ? false: this.state.PuljePuljepraemier ? -1 : 0,
                ElitePuljepraemier:        this.state.ElitePuljepraemier === null            ? false: this.state.ElitePuljepraemier  ? -1 : 0,
                Z_Puljepraemier:           this.state.Z_Puljepraemier === null               ? false: this.state.Z_Puljepraemier ? -1 : 0,
                R_Puljepraemier:           this.state.R_Puljepraemier === null               ? false: this.state.R_Puljepraemier  ? -1 : 0,
                KunEnKontantpraemiePrSlag: this.state.KunEnKontantpraemiePrSlag === null     ? false: this.state.KunEnKontantpraemiePrSlag  ? -1 : 0,
            };

            // Creating new row or updating existing
            if(!this.props.section.Markering){
                this.props.dispatch(AdminActions.createMarking(this.props.sectionNo, entity, onSuccess))
            } else {
                this.props.dispatch(AdminActions.updateMarking(this.props.sectionNo, entity, onSuccess));
            }
        }
    }
}

const mapStateToProps = (state) => ({

});

export default connect(mapStateToProps, null, null, {withRef: true})(SettingsPrizes);



// WEBPACK FOOTER //
// ./src/client/src/components/pages/settings/subPages/SettingsPrizes.js